<template>
  <div class="my-toopbar-body">
    <div class="my-toopbar-cont">
      <div @click="checkItem('/dingWorkbench')" class="my-toopbar-item" :class="activeItem=='/dingWorkbench'?'toopbar-active':''">
        <img v-show="activeItem=='/dingWorkbench'"  src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/icons_home_active.svg" alt="">
        <img v-show="activeItem!='/dingWorkbench'" src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/icons_home.svg" alt="">
        <div>首页</div>
      </div>
      <div @click="checkItem('/myPage')" class="my-toopbar-item" :class="activeItem=='/myPage'?'toopbar-active':''">
        <img v-show="activeItem!='/myPage'"  src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/icons_user.svg" alt="">
        <img v-show="activeItem=='/myPage'"  src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/icons_user_active.svg" alt="">
        <div>我的</div>
      </div>
    </div>
  </div>
</template>
<script>
  
  export default {
    props: ['show'],
    data () {
      return {
        activeItem:'',
      }
    },
    components: {
    },
    created () {
      // console.info(this.$router)
      this.activeItem=window.location.pathname
    },
    mounted () {

    },
    methods: {
      checkItem(url){
        this.$router.push({
          path:url
        })
      }
    }
  }
</script>
<style>
  .my-toopbar-body{
    position: fixed;
    bottom: 0;
    left:0;
    width: 100%;
    background: #fff;
    text-align: center;
    padding-top:10px;
    padding-bottom:15px;
    color:#606266;
    font-size: 14px;
    z-index: 100;
    box-shadow: 0 -2px 6px 0 rgba(0,0,0,0.06);
  }
  .my-toopbar-body .my-toopbar-cont{
    display: flex;
  }
  .my-toopbar-body .my-toopbar-item{
    width: 50%;
    height: auto;
    align-items: center;
  }
 .my-toopbar-body img{
    width: 22px;
    height: 24px;
  }
  .my-toopbar-body .toopbar-active{
    color:#A98463;
    font-weight: bold;
  }
</style>


// WEBPACK FOOTER //
// src/pages/dingWorkbench/components/toopbar.vue